export const unknown = '';
export const jpg = '.jpg';
export const pdf = '.pdf';
export const psd = '.psd';
export const skp = '.skp';
export const png = '.png';
